import { render, staticRenderFns } from "./sendCodeBtn.vue?vue&type=template&id=af120b2c&scoped=true&"
import script from "./sendCodeBtn.vue?vue&type=script&lang=js&"
export * from "./sendCodeBtn.vue?vue&type=script&lang=js&"
import style0 from "./sendCodeBtn.vue?vue&type=style&index=0&id=af120b2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af120b2c",
  null
  
)

export default component.exports